import React, { useEffect } from 'react';
import ContactForm from "./ContactForm"; 
import { Link } from "react-router-dom";
function HomePage() {
  useEffect(() => {
    const scriptPaths = [
      '/js/jquery.min.js',
      '/js/popper.min.js',
      '/js/bootstrap.min.js',
      '/js/nav-menu.js',
      '/search/search.js',
      '/js/easy.responsive.tabs.js',
      '/js/owl.carousel.js',
      '/js/jarallax.min.js',
      '/js/jarallax-video.js',
      '/js/jquery.stellar.min.js',
      '/js/waypoints.min.js',
      '/js/odometer.min.js',
      '/js/countdown.js',
      '/js/jquery.magnific-popup.min.js',
      '/js/animated-headline.js',
      '/js/wow.js',
      '/js/smoothscroll.js',
      '/js/lightgallery-all.js',
      '/js/jquery.mousewheel.min.js',
      '/js/main.js',
      '/quform/js/plugins.js',
      '/quform/js/scripts.js',
    ];

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = Math.round((scrollTop / docHeight) * 100);
      const scrollValueSpan = document.getElementById("scroll-value");
      if (scrollValueSpan) {
        scrollValueSpan.textContent = `${scrollPercent}%`;
      }
    };

    const loadScriptsInOrder = async () => {
      for (const src of scriptPaths) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.onload = resolve;
          script.onerror = () => {
            console.error(`Failed to load ${src}`);
            reject();
          };
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsInOrder();
    window.addEventListener("scroll", handleScroll);

    // Cleanup function
    return () => {
      scriptPaths.forEach((src) => {
        const scripts = document.querySelectorAll(`script[src="${src}"]`);
        scripts.forEach((script) => script.remove());
      });
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

return (
  <div className="main-wrapper">
    <header className="header-style1 menu_area-light">
      <div className="container-fluid px-lg-1-6 px-xl-2-5 px-xxl-2-9">
        <div className="row align-items-center">
          <div className="col-12 col-lg-12">
            <div className="menu_area alt-font"></div>
          </div>
        </div>
      </div>
    </header>

    <section className="full-screen top-position1 p-0">
      <div className="slider-fade01 owl-carousel owl-theme w-100 min-vh-100">
        <div
          className="item bg-img cover-background left-overlay-secondary"
          data-overlay-dark="85"
          data-background="/img/banner/slide-01.jpg"
        >
          <div className="container d-flex flex-column">
            <div className="row align-items-center min-vh-100">
              <div className="col-md-11 col-lg-9 col-xl-8 col-xxl-7">
                <div className="mt-5 mt-sm-0">
                  <h1 className="ls-minus-2px display-1 font-weight-800 lh-1 mb-2-6 mb-lg-2-9 text-white animated fadeInUp">
                    Empowering hands, enriching lives
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="item bg-img cover-background left-overlay-secondary"
          data-overlay-dark="85"
          data-background="/img/banner/slide-02.jpg"
        >
          <div className="container d-flex flex-column">
            <div className="row align-items-center min-vh-100">
              <div className="col-md-11 col-lg-9 col-xl-8 col-xxl-7">
                <div className="mt-5 mt-sm-0">
                  <h1 className="ls-minus-2px display-1 font-weight-800 lh-1 mb-2-6 mb-lg-2-9 text-white animated fadeInUp">
                    Lighting minds, shaping futures
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="item bg-img cover-background left-overlay-secondary"
          data-overlay-dark="85"
          data-background="/img/banner/slide-03.jpg"
        >
          <div className="container d-flex flex-column">
            <div className="row align-items-center min-vh-100">
              <div className="col-md-11 col-lg-9 col-xl-8 col-xxl-7">
                <div className="mt-5 mt-sm-0">
                  <h1 className="ls-minus-2px display-1 font-weight-800 lh-1 mb-2-6 mb-lg-2-9 text-white animated fadeInUp">
                    Strength, spirit and discipline in action
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="item bg-img cover-background left-overlay-secondary"
          data-overlay-dark="85"
          data-background="/img/banner/slide-04.jpg"
        >
          <div className="container d-flex flex-column">
            <div className="row align-items-center min-vh-100">
              <div className="col-md-11 col-lg-9 col-xl-8 col-xxl-7">
                <div className="mt-5 mt-sm-0">
                  <h1 className="ls-minus-2px display-1 font-weight-800 lh-1 mb-2-6 mb-lg-2-9 text-white animated fadeInUp">
                    Learning today, leading tomorrow
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="item bg-img cover-background left-overlay-secondary"
          data-overlay-dark="85"
          data-background="/img/banner/slide-05.jpg"
        >
          <div className="container d-flex flex-column">
            <div className="row align-items-center min-vh-100">
              <div className="col-md-11 col-lg-9 col-xl-8 col-xxl-7">
                <div className="mt-5 mt-sm-0">
                  <h1 className="ls-minus-2px display-1 font-weight-800 lh-1 mb-2-6 mb-lg-2-9 text-white animated fadeInUp">
                    Healing with care,serving with love
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* ABOUT US */}
    <section className="about-style04 pb-20">
      <div className="container">
        <div className="row g-lg-3 mt-n8">
          <div className="col-lg-6 mt-8">
            <div className="position-relative about-left">
              <div className="row">
                {/* <div className="col-sm-5 d-none d-sm-block wow fadeInDown" data-wow-delay="100ms">
              <div className="bg-img cover-background border-radius-10 height-560px image-hover" data-background="/img/content/about-01.jpg"></div>
            </div> */}
                <div className="col-sm-12 wow fadeInUp" data-wow-delay="200ms">
                  <div
                    className="bg-img cover-background border-radius-10 height-560px image-hover"
                    data-background="/img/content/about-02.jpg"
                  ></div>
                </div>
              </div>
              {/* <div className="exp-box wow fadeInUp" data-wow-delay="200ms">
            <div className="row g-0">
              <div className="col-sm-4">
                <div className="bg-img cover-background h-100" data-background="/img/content/about-03.jpg"></div>
              </div>
              <div className="col-sm-8">
                <div className="d-flex py-4 px-4">
                  <div className="flex-shrink-0 me-3">
                    <img src="img/icons/icon-01.png" alt="..." className="w-55px" />
                  </div>
                  <div className="flex-grow-1">
                    <div className="font-weight-800 text-secondary display-27">
                      <div className="odometer odometer-auto-theme" data-count="12">0</div> years
                    </div>
                    <span className="display-30">Serve to Community</span>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
            </div>
          </div>
          <div className="col-lg-6 mt-8">
            <div className="about-right ps-lg-1-9 ps-xxl-10">
              <div
                className="section-title01 mb-2-9 wow fadeInUp"
                data-wow-delay="100ms"
              >
                <span>About Us</span>
                <h2 className="mb-0 display-4 font-weight-800 lh-1 ls-minus-2px">
                  Outreach Map
                </h2>
              </div>
              <div
                className="horizontaltab tab-style01 wow fadeInUp"
                data-wow-delay="150ms"
              >
                <div className="resp-tabs-container hor_1 p-0">
                  <div>
                    <p className="mb-1-9 display-28">
                      Shamayita Math is an Indian non-governmental organization
                      that envisions empowering marginalized communities through
                      self-knowledge and self-consciousness, irrespective of
                      social background, beliefs, or religious affiliations. It
                      works to uplift underserved communities with an emphasis
                      on empowering women in both rural and urban areas of
                      India. It does so by enhancing its capabilities and
                      promoting sustainable development.
                    </p>
                    <p className="mb-1-9 display-28">
                      Founded in 1996, it is registered as a society. Shamayita
                      Math began its journey with a passionate group of young
                      sannyasins (female monks) who dedicated their lives to the
                      service of humanity.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12 mt-6">
            <div className="about-right ps-lg-1-9 ps-xxl-10">
              <div
                className="section-title01 mb-2-9 wow fadeInUp"
                data-wow-delay="100ms"
              >
                <div className="resp-tabs-container hor_1 p-0">
                  <div>
                    <p className="mb-1-9 display-28">
                      It concentrates on the themes of livelihoods, education,
                      health, skill development, inclusion of differently abled,
                      and sports with a strong impetus on spiritualism acting as
                      a bedrock to execute its work. Its head office is in
                      Bankura district, West Bengal, located amidst the paddy
                      fields and the picturesque backdrop of Koro, a small
                      hillock in the east, and Susunia hill in the west.
                    </p>
                    <p className="mb-1-9 display-28">
                      Shamayita Math, an Indian non-governmental organization
                      established in 1996, is dedicated to empowering
                      marginalized communities through self-awareness and
                      self-knowledge, transcending social, cultural, and
                      religious boundaries. It focuses on uplifting underserved
                      populations, with a particular emphasis on empowering
                      women in rural and urban India, by fostering sustainable
                      development and enhancing capabilities.
                    </p>
                    <p className="mb-1-9 display-28">
                      Registered as a society, Shamayita Math was founded by a
                      committed group of young sannyasins (female monks) devoted
                      to serving humanity. The organization prioritizes
                      livelihoods, education, health, skill development,
                      inclusion of differently-abled individuals, and sports,
                      all underpinned by a strong foundation of spiritual
                      values. Its headquarters, located in West Bengal’s Bankura
                      district, is nestled among paddy fields with the scenic
                      Koro hillock to the east and Susunia hill to the west.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* AREAS OF ACHIEVEMENTS */}
    <section className="bg-secondary mx-xxl-1-9 border-radius-10">
      <div className="container">
        <div
          className="section-title01 mb-2-9 text-center wow fadeInUp"
          data-wow-delay="100ms"
        >
          <span>Moments and Milestones</span>
          <h2 className="mb-0 display-4 font-weight-800 lh-1 text-white w-md-70 w-lg-60 w-xl-50 mx-auto ls-minus-2px">
            Nurturing Every Life, Enabling Every Dream
          </h2>
        </div>
        <div className="row mt-n5">
          {/* Card 1 */}
          <div
            className="col-md-6 col-xl-4 mt-5 wow fadeInUp"
            data-wow-delay="100ms"
          >
            <div className="card card-style05 border-0 border-radius-10 bg-transparent">
              <div className="image-hover">
                <img
                  src="img/service/service-01.jpg"
                  alt="..."
                  className="border-radius-10"
                />
              </div>
              <div className="card-body mx-1-9 text-center bg-white mt-n5 border-radius-10 p-0 position-relative z-index-9">
                <div className="service-icon">
                  <img
                    src="img/icons/philosophy.png"
                    alt="..."
                    className="w-40px"
                  />
                </div>
                <h3 className="h5">
                  <a href="#">Events and Celebrations</a>
                </h3>
                <p className="w-80 mx-auto">
                  Shamayita Math celebrates its festivals and observances to uphold its timeless values, creating spaces where people unite in joy, harmony, and shared traditions.
                </p>
                <div className="service-btn">
                  <Link to="/events" className="py-3 d-block">
                    Read More
                    <i className="ti-arrow-top-right display-30 ps-4"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* Card 2 */}
          <div
            className="col-md-6 col-xl-4 mt-5 wow fadeInUp"
            data-wow-delay="200ms"
          >
            <div className="card card-style05 border-0 border-radius-10 bg-transparent">
              <div className="image-hover">
                <img
                  src="img/service/service-02.jpg"
                  alt="..."
                  className="border-radius-10"
                />
              </div>
              <div className="card-body mx-1-9 text-center bg-white mt-n5 border-radius-10 p-0 position-relative z-index-9">
                <div className="service-icon">
                  <img
                    src="img/icons/service.png"
                    alt="..."
                    className="w-40px"
                  />
                </div>
                <h3 className="h5">
                  <a href="#">Dreams turning into dignity</a>
                </h3>
                <p className="w-80 mx-auto">
                  Inspired by the strength of Devi Durga, these success stories celebrate rural women rising with dignity, shaping their own futures through Shamayita’s support.
                </p>
                <div className="service-btn">
                  <Link to="/projects" className="py-3 d-block">
                    Read More
                    <i className="ti-arrow-top-right display-30 ps-4"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* Card 3 */}
          <div
            className="col-md-6 col-xl-4 mt-5 wow fadeInUp"
            data-wow-delay="300ms"
          >
            <div className="card card-style05 border-0 border-radius-10 bg-transparent">
              <div className="image-hover">
                <img
                  src="img/service/service-03.jpg"
                  alt="..."
                  className="border-radius-10"
                />
              </div>
              <div className="card-body mx-1-9 text-center bg-white mt-n5 border-radius-10 p-0 position-relative z-index-9">
                <div className="service-icon">
                  <img
                    src="img/icons/potential.png"
                    alt="..."
                    className="w-40px"
                  />
                </div>
                <h3 className="h5">
                  <a href="#">Nurturing every ability</a>
                </h3>
                <p className="w-80 mx-auto">
                  Be it in classrooms, on the field, or through special care, each story affirms that learning is the essence of holistic development.
                </p>
                <div className="service-btn">
                  <Link to="/projects" className="py-3 d-block">
                    Read More
                    <i className="ti-arrow-top-right display-30 ps-4"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* WHY CHOOSE US */}
    <section className="why-choose-01">
      <div className="container">
        <div className="row mb-6 mb-lg-8 justify-content-between align-items-center mt-n1-9">
          <div className="col-lg-6 col-xxl-5 mt-1-9 order-2 order-lg-1">
            <div>
              <div
                className="section-title01 mb-1-9 mb-lg-2-9 wow fadeInUp"
                data-wow-delay="100ms"
              >
                <span>Why Choose Us</span>
                <h2 className="mb-0 display-4 font-weight-800 lh-1 ls-minus-2px">
                  Areas of Work
                </h2>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 mt-1-9 order-1 order-lg-2 wow fadeInUp"
            data-wow-delay="100ms"
          >
            <div
              className="bg-img cover-background border-radius-10 height-560px image-hover"
              data-background="/img/content/about-12.jpg"
            ></div>
          </div>
        </div>

        {/* Our Partners */}
        <div className="row mt-8 p-1-9 border-radius-10">
          <div className="mb-2-6 text-center">
            <h2 className="display-5 font-weight-800 lh-1 mb-0">
              Our <span className="font-weight-400">Partners</span>
            </h2>
          </div>

          {[...Array(15).keys()].map((idx) => (
            <div
              key={idx}
              className="col-lg-6 col-xl-2 mt-1-9 wow fadeInUp"
              data-wow-delay="100ms"
            >
              <div className="d-flex">
                <div className="flex-grow-1">
                  <img
                    src={`img/icons/partner-${idx + 1}.png`}
                    alt={`Partner ${idx + 1}`}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CONTACT DETAILS */}
    <section className="contact-style01">
      <div className="container">
        <div className="row mt-n1-9">
          <div className="col-lg-7 mt-1-9">
            <div className="border border-color-light-black p-1-9 p-md-5 border-radius-10">
              <div
                className="section-title01 mb-1-9 wow fadeInUp"
                data-wow-delay="100ms"
              >
                <span>Contact Us</span>
                <h2 className="mb-0 display-4 font-weight-800 lh-1 ls-minus-2px">
                  Let's get in touch
                </h2>
              </div>
              <p className="wow fadeInUp" data-wow-delay="100ms">
                Let us know who you are and what you're looking for below, and
                we'll get back to you within 24 hours.
              </p>
              
                 <ContactForm />
              
            </div>
          </div>

          <div className="col-lg-5 mt-1-9">
            <div className="border bg-light border-color-light-black p-1-9 p-md-5 border-radius-10 h-100 d-flex flex-column align-content-around flex-wrap">
              <div
                className="text-center border-bottom border-color-light-black pb-1-9 mb-1-9 wow fadeInUp"
                data-wow-delay="100ms"
              >
                <div className="contact-icon">
                  <i className="fa-solid fa-envelope-open-text"></i>
                </div>
                <h3 className="h4">Email Address</h3>
                <a href="mailto:info@gmail.com" className="d-block">
                  contactus@shamayitamath.in
                </a>
                {/* <a href="mailto:info@gmail.com" className="d-block">
                  info@gmail.com
                </a> */}
              </div>

              <div
                className="text-center border-bottom border-color-light-black pb-1-9 mb-1-9 wow fadeInUp"
                data-wow-delay="100ms"
              >
                <div className="contact-icon">
                  <i className="fa-solid fa-phone-volume"></i>
                </div>
                <h3 className="h4">Phone Number</h3>
                <a href="tel:+91123456789" className="d-block">
                  (+91) 9064102591
                </a>
                {/* <a href="tel:+91152567987" className="d-block">
                  (+91) 152-567-987
                </a> */}
              </div>

              <div className="text-center wow fadeInUp" data-wow-delay="100ms">
                <div className="contact-icon">
                    <i className="fa-solid fa-location-dot"></i>
                </div>

                <h3 className="h4">Shamayita Math Head Office</h3>
                <p className="mb-0">Ranbahal, Amarkanan, Bankura- 722133.</p>

                <h3 className="h4 pt-2">Coordination office</h3>

                <p className="mb-2">
                  ● Durgapur (West Bengal) DII/9,4/34, Sarojini Naidu Path, City Centre, Durgapur -16
                </p>

                <p className="mb-2">
                  ● Jhargram (West Bengal) Shamayita Srotoswini, Kadamkanan, Jhargram, Dist. - West Midnapore
                </p>

                <p className="mb-2">
                  ● Maa Manasa Apartment, 575 S. K. Deb Road, Flat 1C, 1st Floor, Kolkata – 700048
                </p>

                <p className="mb-2">
                  ● Shamayita Math, House no.5, Maansi Sadan, Near Narayan Mandir, District Dakshin Bastar Dantewada, Chhattisgarh – 494449
                </p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* GOOGLE MAP */}
    <section className="py-0">
      <iframe
        title="Shamayita Math Location"
        width="100%"
        height="450"
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src="https://www.google.com/maps?q=Shamayita+Math,+Ranbahal,+West+Bengal+722133&output=embed"
      />
    </section>




    <div className="scroll-top-percentage">
      <span id="scroll-value">0%</span>
    </div>

    {/* Add more JSX-formatted sections here if needed */}
  </div>
);
}

export default HomePage;
